import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "./queryKeys";

const fetchDepartmentViewDetails = async (departmentId) => {
  const params = {};
  if (departmentId != null && departmentId !== "") {
    params.departmentId = departmentId;
  }
  const response = await api.get("/department-info/details", { params });
  return response?.data?.data ?? response?.data;
};

export const useDepartmentViewDetails = (departmentId, options = {}) => {
  const { enabled = true } = options;
  return useQuery({
    queryKey: queryKeys.departmentView.details(departmentId),
    queryFn: () => fetchDepartmentViewDetails(departmentId),
    staleTime: 10 * 60 * 1000,
    // Do not keep previous department payload while switching — avoids stale UI and missing loader.
    enabled,
  });
};
